import React from 'react';
import PropTypes from 'prop-types';
import { getClass } from '../../../../utils/component-helpers';

import './form-page.scss';

const FormNav = props => {
  const { currentStep, steps } = props;

  const Step = (step, stepLabel, isLast) => {
    const selected = step === currentStep;
    return (
      <div key={stepLabel} className={getClass('form-nav-step', { selected })}>
        <div className="step-number">{step + 1}</div>
        <div className="step-label">{stepLabel}</div>
        {!isLast && <div className="divider">|</div>}
      </div>
    );
  };

  return (
    <div className="form-nav">
      {steps.map((step, idx) => Step(idx, step, idx === steps.length - 1))}
    </div>
  );
};

FormNav.propTypes = {
  currentStep: PropTypes.number.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

FormNav.defaultProps = {};

export default FormNav;
